import type { FaireProductEntity } from "../../entity_types/product";

export const p_b8udbd9mvz: FaireProductEntity = {
  token: "p_b8udbd9mvz",
  type: "product",
  name: "Hellbender Hell Yeah 15oz Coffee Mug - Green",
  brandToken: "b_557ocq7k0h",
  brandName: "Allegheny Outfitters",
  imageUrl:
    "https://cdn.faire.com/fastly/07f18757694659ae992e9e7db413e01a5112e1d6c8d8052842866f1a979c5003.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f9453f4133fffd03a315930e5d609f082f7a7740c619753269dafa5c9ad56d99.jpeg",
    "https://cdn.faire.com/fastly/90cd163a77b48ac35882e29317e004d27deecb999c7c7d9346653c53cdbd05c4.jpeg",
  ],
  priceDollars: 12.47,
  description:
    "Hellbenders are one of the coolest critters... Hell yeah, hellbender!\n\n15oz. Hand wash recommended.",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:23.527Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
